var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("DEVELOPMENTAL, CONGENITAL CONDITION, BIRTH DEFECT")]),_c('h4',[_vm._v(" A medical abnormality existing at the time of birth as well as neonatal physical or mental abnormalities developing thereafter because of causal factors or conditions present at the time of birth. ")])])
}]

export { render, staticRenderFns }